import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImported = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7128 4.52579C14.4903 5.10884 14.4512 5.07953 14.7404 6.00728C15.0295 6.93503 15.0191 7.93029 14.7105 8.85178C14.402 9.77326 13.8111 10.5742 13.0216 11.1408C12.2321 11.7074 11.2842 12.011 10.3125 12.0084H6.13827",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.14887 11.2587C1.79891 11.0504 1.79614 11.0542 1.55645 10.725C1.31675 10.3957 1.14638 10.0212 1.05566 9.62417C0.964939 9.22714 0.955749 8.81583 1.02865 8.41514C1.10155 8.01445 1.25503 7.63273 1.47978 7.2931C1.70453 6.95346 1.99588 6.66298 2.33619 6.43925C2.6765 6.21552 3.05868 6.06319 3.45958 5.99149C3.86048 5.91979 4.27177 5.93021 4.66853 6.02212C5.06529 6.11403 5.43926 6.28552 5.7678 6.5262C5.87888 5.92701 6.10728 5.35568 6.43987 4.84505C6.77247 4.33441 7.2027 3.89454 7.70583 3.55071C8.20897 3.20688 8.7751 2.96587 9.37168 2.84154C9.96826 2.7172 9.98014 2.73777 10.5404 2.73787",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9498 2.61499L4.17978 13.385",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgImported;
